const validate = (attrs = {}) => {
  const errors = {};

  if (!attrs.exam || !attrs.exam.value) {
    errors.exam = 'Debe seleccionar un examen';
  }

  const selectedStudents = Object.keys(attrs)
    .filter(key => key.indexOf('student_') === 0)
    .some((key) => {
      const value = attrs[key];
      return value === true || value === 'true' || value === 1;
    });

  const selectedStudentsFromList = (attrs.students || [])
    .some(s => s && s.selected);

  if (!selectedStudents && !selectedStudentsFromList) {
    errors.checkAll = 'Debe seleccionar por lo menos un alumno';
  }

  return errors;
};

export default validate;
